import { render } from "./VisaSettings.vue?vue&type=template&id=1ccf88de&scoped=true"
import script from "./VisaSettings.vue?vue&type=script&lang=js"
export * from "./VisaSettings.vue?vue&type=script&lang=js"

import "./VisaSettings.vue?vue&type=style&index=0&id=1ccf88de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccf88de"]])

export default __exports__